import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * «Hay cambios nuevos · Recargar» (spec 275, R3): otra persona o una corrida
 * cambiaron algo mientras se miraba. Avisa; no recarga solo, para no mover la
 * lista debajo del dedo de quien está decidiendo.
 */
export function AvisoCambiosNuevos({ onRecargar }: { onRecargar: () => void }) {
  return (
    <div
      role="status"
      data-testid="hay-cambios-nuevos"
      className="flex flex-wrap items-center justify-between gap-3 rounded-tarjeta border border-info-borde bg-info-suave px-5 py-3 text-sm text-foreground"
    >
      <span className="flex items-center gap-2">
        <span className="h-2 w-2 shrink-0 animate-pulse rounded-full bg-info" aria-hidden="true" />
        Hay cambios nuevos desde que abriste esta pantalla.
      </span>
      <Button size="sm" variant="outline" onClick={onRecargar} className="gap-1.5 rounded-full">
        <RefreshCw className="h-3.5 w-3.5" aria-hidden="true" />
        Recargar
      </Button>
    </div>
  );
}
